import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { IAccountDomainService } from '../../account';
import { IDocMetaDomainService } from '../../doc-meta';
import { IUserInfoDomainService } from '../../user-info';
import { Emitter } from '@tencent/ark-utils/lib/event';
import { LikeRepo } from '../repository/like';
import { OwnerVipLevelRepo } from '../repository/vip-level';
// 默认的分页数据条数
var PAGE_SIZE = 50;
var LikeEntity = /** @class */ (function () {
    /**
     * 构造方法
     */
    function LikeEntity(docMetaDomain, userInfoDomain, accountDomainService) {
        this.docMetaDomain = docMetaDomain;
        this.userInfoDomain = userInfoDomain;
        this.accountDomainService = accountDomainService;
        this.likeRepo = new LikeRepo(docMetaDomain, userInfoDomain, accountDomainService);
        this.ownerVipRepo = new OwnerVipLevelRepo();
        // 初始化事件监听器
        this.onLikeDataChangedEmitter = new Emitter();
        this.onLikeDataChangedEvent = this.onLikeDataChangedEmitter.event;
    }
    /**
     * 初始化
     */
    LikeEntity.prototype.init = function (params) {
        this.fileId = params.fileId;
        this.ownerId = params.ownerId;
        this.tinyId = params.tinyId;
    };
    /**
     * 初始化。在线打开文档，会自动初始化，但是在容器化、本地调试等没有 basicClientVars 的场景，需要自行调用
     */
    LikeEntity.prototype.initWithBasicClientVars = function (clientVars) {
        var _a, _b, _c, _d, _e, _f, _g;
        // 初始化当前访问的文档和用户
        this.fileId = (_c = (_b = (_a = clientVars.docInfo) === null || _a === void 0 ? void 0 : _a.padInfo) === null || _b === void 0 ? void 0 : _b.padId) !== null && _c !== void 0 ? _c : '';
        this.ownerId = (_f = (_e = (_d = clientVars.docInfo) === null || _d === void 0 ? void 0 : _d.ownerInfo) === null || _e === void 0 ? void 0 : _e.ownerId) !== null && _f !== void 0 ? _f : '';
        this.tinyId = (_g = clientVars.userInfo.tinyId) !== null && _g !== void 0 ? _g : '';
    };
    Object.defineProperty(LikeEntity.prototype, "onLikeDataChanged", {
        /**
         * 点赞数据更新事件 handle
         */
        get: function () {
            return this.onLikeDataChangedEvent;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 对文档点赞
     */
    LikeEntity.prototype.like = function (iconId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.likeRepo.like(this.fileId, iconId)];
            });
        });
    };
    /**
     * 获取支持的点赞类型。个性赞暂时只有几个，所以屏蔽了分页处理，以后看情况再加
     */
    LikeEntity.prototype.getLikeIconList = function (fileId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.likeRepo.getLikeIconList(fileId)];
            });
        });
    };
    /**
     * 获取文档的点赞总数
     */
    LikeEntity.prototype.getLikeRecordCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.likeRepo.getLikeRecordCount(this.fileId)];
            });
        });
    };
    /**
     * 获取点赞列表，默认按时间倒序（组合用户头像昵称）
     * 默认值 -1 表示从最新的数据开始取
     */
    LikeEntity.prototype.getLikeRecordList = function () {
        return __awaiter(this, arguments, void 0, function (from, limit) {
            var result;
            if (from === void 0) { from = -1; }
            if (limit === void 0) { limit = PAGE_SIZE; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.likeRepo.getLikeRecordList(this.fileId, from, limit)];
                    case 1:
                        result = (_a.sent());
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * 处理实时点赞广播消息的方法
     */
    LikeEntity.prototype.handleRealTimeLikeMessage = function (messages) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                // 遍历消息，暂时个性赞消息一次只有一条
                messages.forEach(function (message) { return __awaiter(_this, void 0, void 0, function () {
                    var _a, type, payload;
                    return __generator(this, function (_b) {
                        _a = message.body.notice, type = _a.type, payload = _a.payload;
                        if (type !== 'like') {
                            return [2 /*return*/, console.error('unknown like domain ws message type:', type)];
                        }
                        this.onLikeDataChangedEmitter.fire({
                            newCount: payload.count,
                            newRecord: JSON.parse(payload.like_record),
                        });
                        return [2 /*return*/];
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    /**
     * 设置点赞打开/关闭接口
     */
    LikeEntity.prototype.setLikeEnable = function (enable) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.likeRepo.setLikeEnable(this.fileId, enable)];
                    case 1:
                        result = (_b.sent());
                        if (((_a = result.data) === null || _a === void 0 ? void 0 : _a.retcode) !== 0) {
                            throw Error('/cgi-bin/like/enable/set Request failed');
                        }
                        return [2 /*return*/, result.data.result];
                }
            });
        });
    };
    /**
     * 当前文档是否启用个性赞功能
     * 1、如果被后台判定禁止的文档，严格关闭个性赞
     * 2、如果已经开启按比例灰度的，按照 ownerId 尾号百分比哈希
     * 3、比例灰度没有命中的，vip 文档开启（目前 doc/sheet 都已经 100%，这段理论上是 unreachable code。暂时保留，后面可能其他品类会用到）
     */
    LikeEntity.prototype.isLikeEnable = function (percents) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isBannedByFile()];
                    case 1:
                        if (_a.sent()) {
                            return [2 /*return*/, false];
                        }
                        if (this.isInOwnerIdTailHash(percents)) {
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, this.isVipDoc()];
                }
            });
        });
    };
    LikeEntity.prototype.isBannedByFile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, err_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.likeRepo.isBanned(this.fileId)];
                    case 1:
                        result = (_c.sent());
                        return [2 /*return*/, (_b = (_a = result.data.result) === null || _a === void 0 ? void 0 : _a.is_disabled) !== null && _b !== void 0 ? _b : false];
                    case 2:
                        err_1 = _c.sent();
                        // 谨慎起见，异常情况下，当作被禁止
                        return [2 /*return*/, true];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LikeEntity.prototype.isVipDoc = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, err_2;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.ownerVipRepo.getOwnerVipLevel(this.fileId)];
                    case 1:
                        res = (_c.sent());
                        if ((_a = res.data.result) === null || _a === void 0 ? void 0 : _a.vip_level) {
                            return [2 /*return*/, ((_b = res.data.result) === null || _b === void 0 ? void 0 : _b.vip_level) > 1];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _c.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    LikeEntity.prototype.isInOwnerIdTailHash = function (percents) {
        // 根据 ownerId 尾号哈希控制灰度百比例
        if (percents && this.ownerId) {
            return parseInt(this.ownerId.slice(-2), 10) % 100 < percents;
        }
        return false;
    };
    LikeEntity = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, IUserInfoDomainService),
        __param(2, IAccountDomainService),
        __metadata("design:paramtypes", [Object, Object, Object])
    ], LikeEntity);
    return LikeEntity;
}());
export { LikeEntity };
